import { DEVELOPMENT, PRODUCTION } from './constants';

export const LOCAL_STORAGE_FLAG = 'i18nResourceType';

type ResourceType = typeof DEVELOPMENT | typeof PRODUCTION;

export const getResourceTypeFromLocalStorage = (): ResourceType | undefined => {
  const localStorageFlag = window.localStorage.getItem(LOCAL_STORAGE_FLAG);

  if (localStorageFlag === null) {
    return undefined;
  }

  if (localStorageFlag === DEVELOPMENT) {
    return DEVELOPMENT;
  }

  if (localStorageFlag === PRODUCTION) {
    return PRODUCTION;
  }

  return undefined;
};
